import { IApplicationState, useAppSelector } from '../../libs/store/reducers';

export const useCustomAppSelector = () => {
    const { rbacData } = useAppSelector((state: IApplicationState) => ({
        rbacData: state.rbac.RBACData
      }));
  return rbacData;
};
